// extracted by mini-css-extract-plugin
module.exports = {"colorSampleList":"Xgz5B"};